import { render, staticRenderFns } from "./BackgroundVideo.vue?vue&type=template&id=2d3fe69f&scoped=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=js"
export * from "./BackgroundVideo.vue?vue&type=script&lang=js"
import style0 from "./BackgroundVideo.vue?vue&type=style&index=0&id=2d3fe69f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3fe69f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3fe69f')) {
      api.createRecord('2d3fe69f', component.options)
    } else {
      api.reload('2d3fe69f', component.options)
    }
    module.hot.accept("./BackgroundVideo.vue?vue&type=template&id=2d3fe69f&scoped=true", function () {
      api.rerender('2d3fe69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/default/BackgroundVideo.vue"
export default component.exports